import { ThemeOptions } from '@mui/material';
import { tokens } from '../../../../theme/generated/tokens';

export const chartTooltipTheme: ThemeOptions['components'] = {
  DsChartTooltip: {
    styleOverrides: {
      root: {
        minWidth: 230,
        backgroundColor: tokens.theme.bg.structural.surface,
        borderRadius: tokens.theme.radius.md,
        boxShadow: tokens.theme.shadows.elevation.medium,
      },
    },
  },
};
